import { IconProvider } from './social-media.pipe';

export const provideSocialMediaIconResolver = (iconProvider: (icon: string) => string) => [
  { provide: IconProvider, useValue: iconProvider },
];
